export default __webpack_public_path__ + "static/brianf-bitmoji-a49bcf285cff0717559c8149b62b0f20.png";